import * as React from 'react';
import { app, dialog } from "@microsoft/teams-js";
import { RouteComponentProps } from 'react-router-dom';
import { initializeIcons } from '@fluentui/react';
import { Box, Checkbox, List, Image, Button, Input, TextArea, Dropdown, Text, Flex, FlexItem, Menu, Tooltip, Slider } from '@fluentui/react-northstar';
import { AddIcon, CalendarIcon, InfoIcon, CloseIcon, WindowRestoreIcon, ExclamationCircleIcon, SpeakerPersonIcon, ShieldKeyholeIcon, SettingsIcon, PersonIcon, ChannelShareIcon } from '@fluentui/react-icons-northstar';
import { createOrUpdateServentia, getMeetingData, getGroups } from '../../../api/teamsapp-api';
import { getAppSettings, getUserGroups, searchGroups } from '../../../api/settings-api';
import { LoaderFormBalcaoVirtual } from "../../loaders/loaders";
import { CommonHelper } from '../../../helpers/common-helper';
import { ImageUtil } from '../../../helpers/avatar-helper';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { getBookings, getServices } from '../../../api/bookings-api';
import { updateLocale } from '../../../i18n';
import Constants from '../../../constants/data';
import Channels from '../../../constants/channels';
import Features from '../../../constants/features';
import './unidade.scss';

const _ = require('lodash');

export interface ServiceUnitState {
    ancora: string,
    rowKey: string,
    partitionKey: string,
    title: string,
    descricao?: string,
    assunto?: string,
    listAssuntos: string[],
    secaoJudiciaria?: string,
    active: boolean,
    horarioAtendimentoInicial?: string,
    horarioAtendimentoFinal?: string,
    diasAtendimento?: any[],
    itemsTiposCategorias: any[],
    loader?: boolean,
    loading: boolean,
    isEdit: boolean,
    isValidBookingsUrl?: boolean,
    isValidHorarioInicial?: boolean,
    isValidHorarioFinal?: boolean,
    isValidHorario?: boolean,
    isValidAncora?: boolean,
    activeQueueLimit: boolean,
    queueLimit: number,
    queueLimitData: number,
    groups: any[],
    selectedAtendentes: dropdownItem[],
    selectedAtendentesId: string;
    noResultMessage: string,
    savedNewItem: boolean,
    selectedMenu: number,
    scheduledQueue: boolean,
    sharedMailboxEmail?: string | null,
    authEnabled: boolean,
    govBrEnabled: boolean,
    externalAccessEnabled: boolean,
    internalAccessEnabled: boolean,
    bookingsEnabled: boolean,
    bookingsList: dropdownItem[],
    loadingBookingsServices: boolean,
    bookingsAllServices: boolean,
    bookingsServices: dropdownItem[],
    bookingsSelectedServices: dropdownItem[],
    bookingsUrl: string,
    bookingsId: string,
    autoRecordingGovernanceEnabled: boolean,
    recordAllMeetings: boolean,
    exportRecordings: boolean,
    error: boolean,
    features: string[],
    endQueueCommentsEnabled?: boolean,
    metadata: Metadata,
}
export interface Metadata {
    [key: string]: string;
}

export interface IServentia {
    ancora: string,
    rowKey: string,
    partitionKey: string,
    name: string,
    descricao?: string,
    horarioAtendimentoInicial?: string,
    horarioAtendimentoFinal?: string,
    horarioAtendimentoDias?: string,
    secaoJudiciaria?: string,
    deleted?: boolean,
    assuntos?: string[],
    queueLimit?: number,
    permissionGroupId?: string | null,
    scheduledQueue?: boolean,
    sharedMailboxEmail?: string | null,
    authEnabled?: boolean,
    govBrEnabled?: boolean,
    supportedChannels: string[],
    bookingsEnabled?: boolean,
    bookingsUrl?: string,
    bookingsId?: string,
    bookingsServices?: string[],
    recordAllMeetings?: boolean,
    exportRecordings?: boolean,
    endQueueCommentsEnabled?: boolean,
}

type dropdownItem = {
    key: string,
    header?: string,
    content?: string,
    image?: string,
    team?: {
        id: string,
    },
}

export type ServiceUnitProps = {} & RouteComponentProps & WithTranslation;

class ServiceUnit extends React.Component<ServiceUnitProps, ServiceUnitState> {
    private localize: TFunction;
    ancora?: any = null;

    constructor(props: ServiceUnitProps) {
        super(props);
        this.localize = this.props.t;
        initializeIcons();

        this.state = {
            ancora: "",
            rowKey: "",
            partitionKey: "",
            title: "",
            descricao: "",
            assunto: "",
            listAssuntos: [],
            secaoJudiciaria: "",
            active: true,
            horarioAtendimentoInicial: "",
            horarioAtendimentoFinal: "",
            diasAtendimento: [],
            itemsTiposCategorias: [],
            loader: true,
            loading: false,
            isEdit: false,
            isValidBookingsUrl: true,
            isValidHorarioInicial: true,
            isValidHorarioFinal: true,
            isValidHorario: true,
            isValidAncora: true,
            activeQueueLimit: false,
            queueLimit: 0,
            queueLimitData: 0,
            groups: [],
            selectedAtendentes: [],
            selectedAtendentesId: "",
            noResultMessage: "",
            savedNewItem: false,
            selectedMenu: 0,
            scheduledQueue: false,
            sharedMailboxEmail: null,
            authEnabled: false,
            govBrEnabled: false,
            externalAccessEnabled: false,
            internalAccessEnabled: false,
            bookingsEnabled: false,
            bookingsList: [],
            loadingBookingsServices: false,
            bookingsAllServices: true,
            bookingsServices: [],
            bookingsSelectedServices: [],
            bookingsUrl: "",
            bookingsId: "",
            autoRecordingGovernanceEnabled: false,
            recordAllMeetings: false,
            exportRecordings: false,
            error: false,
            features: [],
            endQueueCommentsEnabled: false,
            metadata: null,
        }
    }

    public async componentDidMount() {
        app.initialize();
        await this.getAppSettings();

        let params = this.props.match.params;

        if ('id' in params) {
            let id = (this.props.match.params as any).id;

            this.getGroupData(id).then((graphData: any) => {
                this.getItem(id);
            });

            this.setState({
                isEdit: true
            })
        }
        else {
            this.setState({
                loader: false,
            })
        }
    }

    /**
     * Parse week days
     * */
    public getDaysOfWeek = () => {
        return [
            { "header": this.localize("SegundaFeira"), "key": "segunda-feira" },
            { "header": this.localize("TercaFeira"), "key": "terça-feira" },
            { "header": this.localize("QuartaFeira"), "key": "quarta-feira" },
            { "header": this.localize("QuintaFeira"), "key": "quinta-feira" },
            { "header": this.localize("SextaFeira"), "key": "sexta-feira" },
            { "header": this.localize("Sabado"), "key": "sábado" },
            { "header": this.localize("Domingo"), "key": "domingo" }
        ];
    }

    /**
     * Get app settings
     * */
    private getAppSettings = async () => {
        const response = await getAppSettings();

        if (response.status === 200 && response.data) {
            this.setState({
                itemsTiposCategorias: response.data.tiposCategorias ? response.data.tiposCategorias : [],
                autoRecordingGovernanceEnabled: response.data.autoRecordingGovernance,
                features: response.data.featuresList,
            });

            if (response.data.language) {
                updateLocale(response.data.language);
            }

            if (response.data.featuresList && response.data.featuresList.includes(Features.BookingsScheduledQueue)) {
                await this.getBookingsAsync();
            }
        }
    }

    private getItem = async (ancora: any) => {
        try {
            const response = await getMeetingData(ancora);
            const unidadeData = response.data;
            const diasAtendimento: any[] = [];
            const selectedGroups = this.makeDropdownItems(this.state.groups);

            if (unidadeData.horarioAtendimentoDias) {
                if (unidadeData.horarioAtendimentoDias.length > 0) {
                    const diasAtendimentoStr = unidadeData.horarioAtendimentoDias.split(',');

                    diasAtendimentoStr.forEach((item: any) => {
                        this.getDaysOfWeek().filter((day: any) => {
                            if (item.trim() == day.key) {
                                diasAtendimento.push(day);
                            }
                        })
                    })
                }
            }

            if (unidadeData) {
                this.setState({
                    ancora: unidadeData.Ancora,
                    rowKey: unidadeData.rowKey,
                    partitionKey: unidadeData.partitionKey,
                    title: unidadeData.name,
                    descricao: unidadeData.descricao ?? "",
                    secaoJudiciaria: unidadeData.secaoJudiciaria,
                    diasAtendimento: diasAtendimento,
                    horarioAtendimentoInicial: unidadeData.horarioAtendimentoInicial,
                    horarioAtendimentoFinal: unidadeData.horarioAtendimentoFinal,
                    active: !unidadeData.deleted,
                    listAssuntos: unidadeData.assuntos,
                    loader: false,
                    queueLimit: unidadeData.queueLimit,
                    queueLimitData: unidadeData.queueLimit,
                    activeQueueLimit: !!unidadeData.queueLimit,
                    selectedAtendentes: selectedGroups.filter((g: any) => g.key == unidadeData.permissionGroupId),
                    selectedAtendentesId: unidadeData.permissionGroupId,
                    scheduledQueue: unidadeData.scheduledQueue,
                    sharedMailboxEmail: unidadeData.sharedMailboxEmail,
                    authEnabled: unidadeData.authEnabled,
                    govBrEnabled: unidadeData.govBrEnabled,
                    externalAccessEnabled: unidadeData.supportedChannels?.includes(Channels.web) || unidadeData.supportedChannels == null,
                    internalAccessEnabled: unidadeData.supportedChannels?.includes(Channels.bot),
                    bookingsEnabled: unidadeData.supportedChannels?.includes(Channels.bookings),
                    bookingsUrl: unidadeData.bookingsUrl,
                    bookingsId: unidadeData.bookingsId,
                    recordAllMeetings: unidadeData.recordAllMeetings,
                    exportRecordings: unidadeData.exportRecordings,
                    endQueueCommentsEnabled: unidadeData.endQueueCommentsEnabled,
                    metadata: unidadeData.metadata,
                });

                if (unidadeData.bookingsId && unidadeData.supportedChannels?.includes(Channels.bookings)) {
                    await this.getBookingsServicesAsync(unidadeData.bookingsId, unidadeData.bookingsServices);
                }
            }
        } catch (error) {
            return error;
        }
    }

    private onTitleChanged = (event: any) => {
        this.setState({
            title: event.target.value,
        });
    }

    private onDescricaoChanged = (event: any) => {
        this.setState({
            descricao: event.target.value,
        });
    }

    private onAssuntoChange = (event: any) => {
        this.setState({
            assunto: event.target.value,
        });
    }

    private addAssunto = (assunto: any) => {
        let assuntos = this.state.listAssuntos || [];
        assuntos.push(assunto);

        this.setState({
            listAssuntos: assuntos,
            assunto: "",
        });
    }

    private deleteAssunto = (assunto: any, index: number) => {
        var indexAssunto = this.state.listAssuntos.indexOf(assunto);

        if (indexAssunto > -1) {
            this.state.listAssuntos.splice(indexAssunto, 1)
        }

        this.setState({
            listAssuntos: this.state.listAssuntos
        })
    }

    private renderAssuntos(item: any, index: number) {
        return {
            key: index,
            className: 'item-assunto',
            header: item,
            truncateHeader: true,
            endMedia: (
                <CloseIcon circular size="small" styles={{ cursor: 'pointer' }} onClick={() => this.deleteAssunto(item, index)} />
            )
        }
    }

    private onTipoCategoriaChanged = (event: any, itemsData: any) => {
        this.setState({
            secaoJudiciaria: itemsData.value,
        });
    }

    private onSharedMailboxEmailChanged = (event: any) => {
        this.setState({
            sharedMailboxEmail: event.target.value,
        });
    }

    private getBookingsAsync = async () => {
        const response = await getBookings();

        if (response.status === 200 && response.data) {
            this.setState({
                bookingsList: this.makeDropdownItems(response.data, true),
            });
        }
    }

    private getBookingsServicesAsync = async (bookingsId: string, selectedServices?: string[]) => {
        const response = await getServices(bookingsId);

        if (response.status === 200 && response.data) {
            this.setState({
                bookingsServices: this.makeSimpleDropdownItems(response.data),
                bookingsSelectedServices: selectedServices ? this.makeSimpleDropdownItems(response.data.filter(d => selectedServices.includes(d.id))) : [],
                bookingsAllServices: !selectedServices ? true : false,
            });
        }

        if (!response.data.length) {
            this.setState({
                bookingsAllServices: true,
            });
        }
    }

    private onBookingsUrlChanged = (event: any) => {
        var isValidBookingsUrl = true;
        if (event.target.value) {
            isValidBookingsUrl = CommonHelper.validUrl(event.target.value);
        }
        else {
            isValidBookingsUrl = true;
        }

        this.setState({
            bookingsUrl: event.target.value,
            isValidBookingsUrl: isValidBookingsUrl,
        });
    }

    private onBookingsIdChanged = async (event: any) => {
        this.setState({
            bookingsId: event.target.value,
            error: !(event.target.value != ''),
        });
    }

    private copyEnderecoPublicoToClipboard = () => {
        const el = document.createElement('input');
        el.style.position = 'fixed';
        el.style.left = '0';
        el.style.top = '0';
        el.style.opacity = '0';
        el.value = window.location.origin + "/meeting/" + this.state.ancora;
        document.body.appendChild(el);
        el.focus();
        el.select();

        document.execCommand("copy")
        document.body.removeChild(el);
    }

    private onHorarioInicialChange = (event: any, itemData: any) => {
        var isValidHorario = true;
        var isValidHorarioInicial = true;
        if (itemData.value && this.state.horarioAtendimentoFinal) {
            var horarioInicial = itemData.value.replace(":", "");
            var horarioFinal = this.state.horarioAtendimentoFinal.replace(":", "");

            if (Number(horarioInicial) >= Number(horarioFinal)) {
                isValidHorarioInicial = false;
            }
            else {
                isValidHorarioInicial = true;
                this.setState({ isValidHorarioFinal: true });
            }
        }
        else if (itemData.value) {
            isValidHorario = false;
        }

        this.setState({
            horarioAtendimentoInicial: itemData.value,
            isValidHorarioInicial: isValidHorarioInicial,
            isValidHorario: isValidHorario
        })
    }

    private onHorarioFinalChange = (event: any, itemData: any) => {
        var isValidHorario = true;
        var isValidHorarioFinal = true;
        if (itemData.value && this.state.horarioAtendimentoInicial) {
            var horarioFinal = itemData.value.replace(":", "");
            var horarioInicial = this.state.horarioAtendimentoInicial.replace(":", "");

            if (Number(horarioInicial) >= Number(horarioFinal)) {
                isValidHorarioFinal = false;
            }
            else {
                isValidHorarioFinal = true;
                this.setState({ isValidHorarioInicial: true });
            }
        }
        else if (itemData.value) {
            isValidHorario = false;
        }

        this.setState({
            horarioAtendimentoFinal: itemData.value,
            isValidHorarioFinal: isValidHorarioFinal,
            isValidHorario: isValidHorario
        })
    }

    private onDiasAtendimentoChange = (event: any, itemsData: any) => {
        this.setState({
            diasAtendimento: itemsData.value
        })
    }

    private isSaveBtnDisabled = () => {
        return !(this.state.title &&
            this.state.isValidBookingsUrl &&
            this.state.isValidHorarioInicial &&
            this.state.isValidHorarioFinal &&
            this.state.isValidHorario &&
            !this.state.error)
    }

    private onSave = () => {
        let diasAtendimento = "";
        this.state.diasAtendimento?.forEach((item: any) => {
            if (diasAtendimento) {
                diasAtendimento += ", " + item.key;
            }
            else {
                diasAtendimento = item.key;
            }
        });

        const serventia: IServentia = {
            ancora: this.state.ancora,
            rowKey: this.state.rowKey,
            partitionKey: this.state.partitionKey,
            name: this.state.title,
            descricao: this.state.descricao,
            secaoJudiciaria: this.state.secaoJudiciaria,
            deleted: !this.state.active,
            horarioAtendimentoInicial: this.state.horarioAtendimentoInicial,
            horarioAtendimentoFinal: this.state.horarioAtendimentoFinal,
            horarioAtendimentoDias: diasAtendimento,
            assuntos: this.state.listAssuntos,
            queueLimit: this.state.queueLimit,
            permissionGroupId: this.state.selectedAtendentesId == "" ? null : this.state.selectedAtendentesId,
            scheduledQueue: this.state.scheduledQueue,
            sharedMailboxEmail: this.state.sharedMailboxEmail,
            govBrEnabled: this.state.govBrEnabled,
            supportedChannels: this.parseChannels(),
            bookingsUrl: this.state.bookingsUrl,
            bookingsId: this.state.bookingsId,
            bookingsServices: this.state.bookingsSelectedServices.length ? this.state.bookingsSelectedServices.map((service: dropdownItem) => service.key) : null,
            recordAllMeetings: this.state.recordAllMeetings,
            exportRecordings: this.state.exportRecordings,
            endQueueCommentsEnabled: this.state.endQueueCommentsEnabled,
        }

        this.postServentia(serventia).then((response: any) => {
            if (response.status === 409 && !this.state.savedNewItem) {
                this.setState({
                    isValidAncora: false
                })
            }
            else {
                if (!this.state.isEdit) {
                    this.setState({
                        savedNewItem: true,
                        ancora: response.data.Ancora,
                        title: response.data.name,
                        partitionKey: response.data.partitionKey,
                        rowKey: response.data.rowKey,
                        externalAccessEnabled: response.data.supportedChannels?.includes(Channels.web) ?? true,
                        internalAccessEnabled: response.data.supportedChannels?.includes(Channels.bot) ?? false,
                        bookingsEnabled: response.data.supportedChannels?.includes(Channels.bookings) ?? false,
                    });
                } else {
                    dialog.url.submit("submit");
                }
            }
        });
    }

    private parseChannels = () => {
        let channels = [];

        if (this.state.externalAccessEnabled)
            channels.push(Channels.web)
        if (this.state.internalAccessEnabled)
            channels.push(Channels.bot)
        if (this.state.bookingsEnabled)
            channels.push(Channels.bookings)

        return channels;
    }

    private onEdit = async () => {
        this.setState({
            isEdit: true,
            isValidAncora: true,
        })

        dialog.update.resize({ width: 750, height: 650 });
    }

    private postServentia = async (serventia: IServentia) => {
        try {
            return await createOrUpdateServentia(serventia);
        } catch (error) {
            throw error;
        }
    }

    private onCancel = () => {
        dialog.url.submit();
    }

    private toggleDeleteItem = async (event: any, data: any) => {
        this.setState({
            active: data.checked,
        });
    }

    private toggleLimite = async (event: any, data: any) => {
        this.setState({
            activeQueueLimit: data.checked,
            queueLimit: data.checked ? 50 : this.state.queueLimitData,
        });

        if (!data.checked) {
            this.setState({
                queueLimitData: 0,
                queueLimit: 0,
            })
        }
    }

    private toggleScheduledQueue = async (event: any, data: any) => {
        this.setState({
            scheduledQueue: data.checked,
        })

        if (!data.checked) {
            this.setState({
                sharedMailboxEmail: null,
            })
        }
    }

    private changeQueueLimit = (e: any, data: any) => {
        this.setState({
            queueLimit: data.value
        })
    }

    private toggleExternalAccessEnabled = (event: any, data: any) => {
        this.setState({
            externalAccessEnabled: data.checked,
        })
    }

    private toggleInternalAccessEnabled = (event: any, data: any) => {
        this.setState({
            internalAccessEnabled: data.checked,
        })
    }

    private toggleGovBrEnabled = (event: any, data: any) => {
        this.setState({
            govBrEnabled: data.checked,
        });
    }

    private toggleBookingsEnabled = (event: any, data: any) => {
        this.setState({
            bookingsEnabled: data.checked,
            bookingsId: !data.cheched ? "" : this.state.bookingsId,
            bookingsAllServices: true,
            bookingsServices: [],
            bookingsSelectedServices: [],
        });
    }

    private toggleBookingsServices = (event: any, data: any) => {
        this.setState({
            bookingsAllServices: data.checked,
            bookingsSelectedServices: [],
        })
    }

    private toggleAutoRecording = (event: any, data: any) => {
        this.setState({
            recordAllMeetings: data.checked,
        });
    }

    private toggleExportRecordings = (event: any, data: any) => {
        this.setState({
            exportRecordings: data.checked,
        });
    }

    private toggleEndQueueComments = (event: any, data: any) => {
        this.setState({
            endQueueCommentsEnabled: data.checked,
        });
    }

    private getGroupData = async (ancora: string) => {
        try {
            const response = await getUserGroups();
            const responseSettingsGroups = await getGroups(ancora);

            if (response.data && responseSettingsGroups.data) {
                this.setState({
                    groups: _.uniqBy(response.data.concat(responseSettingsGroups.data), 'id'),
                });
            }
        }
        catch (error) {
            return error;
        }
    }

    private onGroupSearch = (itemList: any, searchQuery: string) => {
        const result = itemList.filter(
            (item: { header: string; content: string; }) => (item.header && item.header.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1) ||
                (item.content && item.content.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1),
        )
        return result;
    }

    private getGroupItems = () => {
        if (this.state.groups) {
            return this.makeDropdownItems(this.state.groups);
        }
        const dropdownItems: dropdownItem[] = [];
        return dropdownItems;
    }

    private makeDropdownItems = (items: any[] | undefined, custom?: boolean, hideImage?: boolean) => {
        const resultedTeams: dropdownItem[] = [];
        if (items) {
            items.forEach((element) => {
                resultedTeams.push({
                    key: element.id,
                    header: element.displayName,
                    content: custom ? element.id : element.mail,
                    image: hideImage ? null : ImageUtil.makeInitialImage(element.displayName),
                    team: {
                        id: element.id
                    },

                });
            });
        }
        return resultedTeams;
    }

    private makeSimpleDropdownItems = (items: any[] | undefined) => {
        const resultedTeams: dropdownItem[] = [];
        if (items) {
            items.forEach((element) => {
                resultedTeams.push({
                    key: element.id,
                    header: element.displayName,
                });
            });
        }
        return resultedTeams;
    }

    private onGroupSearchQueryChange = async (event: any, itemsData: any) => {
        if (!itemsData.searchQuery) {
            this.setState({
                noResultMessage: "",
            });
        }
        else if (itemsData.searchQuery && itemsData.searchQuery.length <= 2) {
            this.setState({
                loading: false,
                noResultMessage: this.localize("NenhumaOcorrencia"),
            });
        }
        else if (itemsData.searchQuery && itemsData.searchQuery.length > 2) {
            // handle event trigger on item select.
            const result = itemsData.items && itemsData.items.find(
                (item: { header: string; }) => item.header.toLowerCase() === itemsData.searchQuery.toLowerCase()
            )
            if (result) {
                return;
            }

            this.setState({
                loading: true,
                noResultMessage: "",
            });

            try {
                const query = encodeURIComponent(itemsData.searchQuery);
                const response = await searchGroups(query);
                this.setState({
                    groups: response.data,
                    loading: false,
                    noResultMessage: this.localize("NenhumaOcorrencia"),
                });
            }
            catch (error) {
                return error;
            }
        }

        if (itemsData.searchQuery.length == 0) {
            const response = await getUserGroups();

            this.setState({
                groups: response.data,
                loading: false,
            });
        }
    }

    private onAtendentesChange = (event: any, itemsData: any) => {
        if (itemsData.value.length > 1)
            this.setState({
                selectedAtendentes: itemsData.value[1],
                selectedAtendentesId: itemsData.value[1].key,
            })
        else
            this.setState({
                selectedAtendentes: itemsData.value[0],
                selectedAtendentesId: itemsData?.value.length ? itemsData.value[0].key : "",
            })
    }

    private setActiveTabId = (index: number, item: any) => {
        this.setState({
            selectedMenu: index
        })
    }

    public render(): JSX.Element {
        if (this.state.loader) {
            return (
                <LoaderFormBalcaoVirtual />
            );
        } else {
            if (!this.state.isEdit) {
                return (
                    <div className="taskModule">
                        <div className="formContainer">
                            <div className="formContentContainer" >
                                {!this.state.savedNewItem &&
                                    <Flex column>
                                        <div className="inputField form-section" >
                                            <Text weight="bold" content={`${this.localize("VamosComecar")}!`} />
                                        </div>
                                        <Input
                                            className="inputField"
                                            fluid
                                            value={this.state.title}
                                            label={`${this.localize("QualNomeUnidade")}?`}
                                            onChange={this.onTitleChanged}
                                            error={this.state.title != '' && !this.state.isValidAncora}
                                            errorIndicator={<Tooltip content={this.localize("UnidadeExistente")}><ExclamationCircleIcon /></Tooltip>}
                                            required
                                        />
                                        <Flex hAlign="center" gap="gap.medium" vAlign="center">
                                            <Box className="build">
                                                <Image src="images/build.svg" />
                                            </Box>
                                        </Flex>
                                    </Flex>
                                }

                                {this.state.savedNewItem &&
                                    <Flex hAlign="center" vAlign="center" gap="gap.medium" column>
                                        <Text className="inputField" content={`${this.localize("UnidadeCriada")}!`} />
                                        <Box className="done">
                                            <Image src="images/done.svg" />
                                        </Box>
                                    </Flex>
                                }
                            </div>
                        </div>

                        <div className="footerContainer">
                            <div className="buttonContainer">
                                {!this.state.savedNewItem ?
                                    <Button content={this.localize("Salvar")} id="saveBtn" onClick={this.onSave} primary disabled={this.isSaveBtnDisabled()} />
                                    :
                                    <Button content={this.localize("Personalizar")} id="saveBtn" onClick={this.onEdit} primary />
                                }
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="taskModule">
                        <div className="formContainer">
                            <Flex gap="gap.medium" padding="padding.medium">
                                <Flex.Item size="medium">
                                    <Flex className="settings-menu" gap="gap.small" column>
                                        <Menu
                                            activeIndex={this.state.selectedMenu}
                                            onItemClick={(currentTarget, props) =>
                                                this.setActiveTabId(props && props.index ? props.index : 0, props)
                                            }
                                            items={[
                                                {
                                                    icon: (<InfoIcon outline />),
                                                    key: 'geral',
                                                    content: this.localize("Geral"),
                                                },
                                                {
                                                    icon: (<ShieldKeyholeIcon outline />),
                                                    key: 'acesso',
                                                    content: this.localize("ControleAcesso"),
                                                },
                                                {
                                                    icon: (<CalendarIcon outline />),
                                                    key: 'horario',
                                                    content: this.localize("HorarioComercial"),
                                                },
                                                {
                                                    icon: (<ChannelShareIcon outline />),
                                                    key: 'canais',
                                                    content: this.localize("Canais"),
                                                },
                                                {
                                                    icon: (<SettingsIcon outline />),
                                                    key: 'avancado',
                                                    content: this.localize("Avancado"),
                                                },
                                                //{
                                                //    icon: (<PersonIcon outline />),
                                                //    key: 'govbr',
                                                //    content: this.localize("IdentidadeGovBr"),
                                                //    hidden: !this.state.authEnabled || !this.state.features.includes(Features.GovBrAuthentication),
                                                //},
                                            ]}
                                            vertical
                                        />
                                    </Flex>
                                </Flex.Item>
                                <Flex.Item grow>
                                    <div className="formContentContainer" >
                                        {this.state.selectedMenu == 0 &&
                                            <React.Fragment>
                                                <Flex>
                                                    <Input
                                                        className="inputField"
                                                        fluid
                                                        value={this.state.title}
                                                        label={this.localize("NomeUnidade")}
                                                        onChange={this.onTitleChanged}
                                                        error={this.state.title != '' && !this.state.isValidAncora}
                                                        errorIndicator={<Tooltip content={this.localize("UnidadeExistente")}><ExclamationCircleIcon /></Tooltip>}
                                                        required
                                                    />

                                                    <div className="inputField" style={{ padding: "0 3.2rem 0 0" }}>
                                                        <Text className="label-field" content={this.localize("Ativo")} />
                                                        <Checkbox
                                                            styles={{ paddingLeft: "0px" }}
                                                            checked={this.state.active}
                                                            onChange={this.toggleDeleteItem}
                                                            toggle
                                                        />
                                                    </div>
                                                </Flex>

                                                <div className="inputField" >
                                                    <Text className="label-field" content={this.localize("Descricao")} />
                                                    <TextArea
                                                        variables={{
                                                            height: "120px"
                                                        }}
                                                        fluid
                                                        value={this.state.descricao}
                                                        onChange={this.onDescricaoChanged}
                                                        required
                                                        maxLength={1024}
                                                    />
                                                </div>

                                                <div className="inputField" >
                                                    <Text className="label-field" content={this.localize("Categoria")} />
                                                    <Dropdown
                                                        items={this.state.itemsTiposCategorias}
                                                        fluid
                                                        clearable
                                                        checkable
                                                        placeholder={this.localize("SelecioneCategoria")}
                                                        onChange={this.onTipoCategoriaChanged}
                                                        value={this.state.secaoJudiciaria}
                                                    />
                                                </div>

                                                {!!this.state.metadata &&
                                                    <div className="inputField form-section not-first">
                                                        <Text className="label-field" content={`Informações complementares`} />

                                                        <div className="additional-info">
                                                            {Object.entries(this.state.metadata).map(([key, value]) => (
                                                                <Flex gap="gap.smaller">
                                                                    <span className="metadata-label">{key}: </span>
                                                                    <span className="metadata-value">{value}</span>
                                                                </Flex>
                                                            ))}
                                                        </div>
                                                    </div>
                                                }
                                            </React.Fragment>
                                        }


                                        {this.state.selectedMenu == 1 &&
                                            <React.Fragment>
                                                <div className="inputField permission">
                                                    <Text className="label-field" content={this.localize("Atendentes")} />
                                                    <Dropdown
                                                        multiple
                                                        fluid
                                                        className="hideToggle"
                                                        placeholder={this.localize("GrupoM365")}
                                                        search={this.onGroupSearch}
                                                        loading={this.state.loading}
                                                        loadingMessage={this.localize("Carregando")}
                                                        items={this.getGroupItems()}
                                                        value={this.state.selectedAtendentes}
                                                        onSearchQueryChange={this.onGroupSearchQueryChange}
                                                        onChange={this.onAtendentesChange}
                                                        noResultsMessage={this.state.noResultMessage}
                                                        unstable_pinned={true}
                                                        renderSelectedItem={(SelectedItemComponent, props) => {
                                                            return (
                                                                <Tooltip content={props.header} position="below" align="center">
                                                                    <SelectedItemComponent {...props} />
                                                                </Tooltip>
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </React.Fragment>
                                        }

                                        {this.state.selectedMenu == 2 &&
                                            <React.Fragment>
                                                <div className="inputField diasAtendimento">
                                                    <Text className="label-field" content={this.localize("DiasAtendimento")} />
                                                    <Dropdown
                                                        multiple
                                                        fluid
                                                        clearable
                                                        checkable
                                                        items={this.getDaysOfWeek()}
                                                        placeholder={this.localize("SelecioneDiasAtendimento")}
                                                        onChange={this.onDiasAtendimentoChange}
                                                        value={this.state.diasAtendimento}
                                                    />
                                                </div>

                                                <Flex className="horario">
                                                    <FlexItem size="size.half">
                                                        <div className="inputField">
                                                            <Text className="label-field" content={this.localize("HorariosAtendimento")} />
                                                            <Dropdown
                                                                items={Constants.hoursStart}
                                                                fluid
                                                                clearable
                                                                checkable
                                                                placeholder={this.localize("HorarioInicial")}
                                                                onChange={this.onHorarioInicialChange}
                                                                value={this.state.horarioAtendimentoInicial}
                                                                error={this.state.horarioAtendimentoInicial != '' && !this.state.isValidHorarioInicial}
                                                            />
                                                        </div>
                                                    </FlexItem>
                                                    <FlexItem size="size.half">
                                                        <div className="inputField" >
                                                            <Text className="label-field" styles={{ height: "18px" }} />
                                                            <Dropdown
                                                                items={Constants.hoursEnd}
                                                                fluid
                                                                clearable
                                                                checkable
                                                                placeholder={this.localize("HorarioFinal")}
                                                                onChange={this.onHorarioFinalChange}
                                                                value={this.state.horarioAtendimentoFinal}
                                                                error={this.state.horarioAtendimentoFinal != '' && !this.state.isValidHorarioFinal}
                                                            />
                                                        </div>
                                                    </FlexItem>
                                                </Flex>
                                            </React.Fragment>
                                        }

                                        {this.state.selectedMenu == 3 &&
                                            <React.Fragment>
                                                <div className="inputField form-section first" >
                                                    <Text weight="bold" content={this.localize("Web")} />
                                                </div>

                                                <div className="inputField">
                                                    <Flex vAlign="center" gap="gap.large">
                                                        <Text className="label-field limite" content={this.localize("AcessoExterno")} />
                                                        <Checkbox
                                                            styles={{ margin: "10px 0 0 8px" }}
                                                            checked={(this.state.externalAccessEnabled)}
                                                            onChange={this.toggleExternalAccessEnabled}
                                                            toggle
                                                        />
                                                    </Flex>
                                                    <Flex vAlign="center" gap="gap.large">
                                                        <FlexItem>
                                                            <Input
                                                                hidden={!this.state.isEdit || !this.state.ancora || !this.state.externalAccessEnabled}
                                                                icon={<WindowRestoreIcon onClick={this.copyEnderecoPublicoToClipboard} styles={{ cursor: 'pointer' }} />}
                                                                className="endereco-publico"
                                                                fluid
                                                                value={window.location.origin + "/meeting/" + this.state.ancora}
                                                                label={this.localize("EnderecoPublico")}
                                                                readOnly
                                                                disabled
                                                            />
                                                        </FlexItem>
                                                    </Flex>
                                                </div>

                                                {this.state.features.includes(Features.InternalAssistant) &&
                                                    <React.Fragment>
                                                        <div className="inputField form-section not-first" >
                                                            <Text weight="bold" content={`Teams`} />
                                                        </div>

                                                        <div className={`inputField`}>
                                                            <Flex vAlign="center" gap="gap.large">
                                                                <Text className="label-field limite" content={this.localize("AssistenteAtendimentoInterno")} />
                                                                <Checkbox
                                                                    styles={{ margin: "10px 0 0 8px" }}
                                                                    checked={this.state.internalAccessEnabled}
                                                                    onChange={this.toggleInternalAccessEnabled}
                                                                    toggle
                                                                />
                                                            </Flex>
                                                        </div>
                                                    </React.Fragment>
                                                }


                                                {this.state.features.includes(Features.BookingsScheduledQueue) &&
                                                    <React.Fragment>
                                                        <div className="inputField form-section not-first" >
                                                            <Text weight="bold" content={`Bookings`} />
                                                        </div>

                                                        <div className="inputField">
                                                            <Flex vAlign="center" gap="gap.large">
                                                                <Text className="label-field limite" content={this.localize("IntegrarBookings")} />
                                                                <Checkbox
                                                                    styles={{ margin: "10px 0 0 8px" }}
                                                                    checked={(this.state.bookingsEnabled)}
                                                                    onChange={this.toggleBookingsEnabled}
                                                                    toggle
                                                                />
                                                            </Flex>
                                                            {this.state.bookingsEnabled &&
                                                                <Flex vAlign="center" gap="gap.small" column>
                                                                    <Dropdown
                                                                        className="bookingsList"
                                                                        items={this.state.bookingsList}
                                                                        fluid
                                                                        clearable
                                                                        checkable
                                                                        placeholder={this.localize("SelecioneBookings")}
                                                                        onChange={async (e, data: any) => {
                                                                            this.setState({
                                                                                bookingsId: data.value?.key,
                                                                                bookingsSelectedServices: [],
                                                                                loadingBookingsServices: true,
                                                                            });

                                                                            await this.getBookingsServicesAsync(data.value?.key);
                                                                        }}
                                                                        value={this.state.bookingsId}
                                                                    />

                                                                    {this.state.bookingsId && 
                                                                        <>
                                                                            <Checkbox
                                                                                className="bookingsAllServices"
                                                                                styles={{ margin: "10px 0 0 8px" }}
                                                                                label="Todos os serviços do Bookings ativos"
                                                                                labelPosition="start"
                                                                                checked={this.state.bookingsAllServices}
                                                                                onChange={this.toggleBookingsServices}
                                                                                disabled={!this.state.bookingsServices.length}
                                                                                toggle
                                                                            />

                                                                            {!this.state.bookingsAllServices &&
                                                                                <Dropdown
                                                                                    className={`serviceList ${!this.state.bookingsServices.length ? 'readOnly' : ''}`}
                                                                                    items={this.state.bookingsServices}
                                                                                    multiple
                                                                                    fluid
                                                                                    clearable
                                                                                    checkable
                                                                                    placeholder={!!this.state.bookingsServices.length ? this.localize("SelecioneBookingsServico") : this.localize("BookingsTodosServicos")}
                                                                                    onChange={(e, data: any) => {
                                                                                        this.setState({
                                                                                            bookingsSelectedServices: data.value,
                                                                                        });


                                                                                    }}
                                                                                    value={this.state.bookingsSelectedServices}
                                                                                />
                                                                            }
                                                                        </>
                                                                    }
                                                                </Flex>
                                                            }
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                        }

                                        {this.state.selectedMenu == 4 &&
                                            <React.Fragment>
                                                <div className="inputField form-section" >
                                                    <Text weight="bold" content={this.localize("ControleFila")} />
                                                </div>

                                                <div className="inputField">
                                                    <Flex gap="gap.smaller" column>
                                                        <Flex vAlign="center" gap="gap.large">
                                                            <Text className="label-field limite" content={this.localize("LimiteSolicitacoesSimultaneas")} />
                                                            <Checkbox
                                                                styles={{ margin: "10px 0 0 8px" }}
                                                                checked={!!this.state.activeQueueLimit}
                                                                onChange={this.toggleLimite}
                                                                toggle
                                                            />
                                                        </Flex>
                                                        <Flex vAlign="center" gap="gap.large">
                                                            <FlexItem>
                                                                <Slider
                                                                    fluid
                                                                    min={0}
                                                                    max={100}
                                                                    vertical={false}
                                                                    value={this.state.queueLimit}
                                                                    onChange={this.changeQueueLimit}
                                                                    hidden={!this.state.activeQueueLimit}
                                                                />
                                                            </FlexItem>
                                                            <FlexItem size="size.small">
                                                                <Input
                                                                    icon={<SpeakerPersonIcon />}
                                                                    iconPosition="start"
                                                                    className="pessoasFila"
                                                                    type="number"
                                                                    fluid
                                                                    min={0}
                                                                    max={100}
                                                                    disabled
                                                                    value={this.state.queueLimit}
                                                                    onChange={this.changeQueueLimit}
                                                                    hidden={!this.state.activeQueueLimit}
                                                                />
                                                            </FlexItem>
                                                        </Flex>
                                                    </Flex>
                                                </div>

                                                <div className="inputField form-section not-first" >
                                                    <Text weight="bold" content={this.localize("AgendamentoAtendimento")} />
                                                </div>

                                                <Input
                                                    className="inputField"
                                                    fluid
                                                    value={this.state.bookingsUrl}
                                                    label={this.localize("IntegrarBookings")}
                                                    onChange={this.onBookingsUrlChanged}
                                                    error={this.state.bookingsUrl != '' && !this.state.isValidBookingsUrl}
                                                    errorIndicator={<Tooltip content={this.localize("URLInvalida")}><ExclamationCircleIcon /></Tooltip>}
                                                />

                                                {this.state.features.includes(Features.ScheduledQueue) &&
                                                     <>
                                                        <div className="inputField">
                                                            <Flex vAlign="center" gap="gap.large">
                                                                <Text className="label-field limite" content={this.localize("RegistroFuturo")} />
                                                                <Checkbox
                                                                    styles={{ margin: "10px 0 0 8px" }}
                                                                    checked={this.state.scheduledQueue}
                                                                    onChange={this.toggleScheduledQueue}
                                                                    toggle
                                                                />
                                                            </Flex>
                                                        </div>

                                                        {this.state.scheduledQueue &&
                                                            <div className="inputField">
                                                                <Text className="label-field limite" content={`E-mail do remetente do agendamento`} />
                                                                <Input
                                                                    fluid
                                                                    value={this.state.sharedMailboxEmail}
                                                                    onChange={this.onSharedMailboxEmailChanged}
                                                                />
                                                            </div>
                                                        }
                                                    </>
                                                }

                                                <div className="inputField form-section not-first" >
                                                    <Text weight="bold" content={this.localize("TagsSolicitacao")} />
                                                </div>

                                                <div className="inputField" >
                                                    <Text className="label-field" content={this.localize("TagsDisponiveis")} />
                                                    <Input
                                                        icon={this.state.assunto ? <AddIcon styles={{ cursor: "pointer" }} onClick={() => this.addAssunto(this.state.assunto)} /> : <React.Fragment />}
                                                        fluid
                                                        value={this.state.assunto}
                                                        onChange={this.onAssuntoChange}
                                                    />
                                                </div>

                                                <div className="inputField" >
                                                    <List
                                                        items={this.state.listAssuntos ? this.state.listAssuntos.map(this.renderAssuntos.bind(this)) : []}
                                                    />
                                                </div>

                                                {(this.state.autoRecordingGovernanceEnabled && this.state.features.includes(Features.RecordingGovernance)) &&
                                                    <React.Fragment>
                                                        <div className="inputField form-section not-first">
                                                            <Text weight="bold" content={this.localize("GravacaoAutomatica")} />
                                                        </div>

                                                        <div className="inputField">
                                                            <Flex vAlign="center" gap="gap.large">
                                                                <Text className="label-field limite" content={this.localize("HabilitarGravacao")} />
                                                                <Checkbox
                                                                    styles={{ margin: "10px 0 0 8px" }}
                                                                    checked={this.state.recordAllMeetings}
                                                                    onChange={this.toggleAutoRecording}
                                                                    toggle
                                                                />
                                                            </Flex>
                                                        </div>
                                                    </React.Fragment>
                                                }

                                                {(this.state.autoRecordingGovernanceEnabled && this.state.features.includes(Features.RecordingGovernance)) &&
                                                    <React.Fragment>
                                                        <div className="inputField form-section not-first">
                                                            <Text weight="bold" content={this.localize("ExportarGravacoes")} />
                                                        </div>

                                                        <div className="inputField">
                                                            <Flex vAlign="center" gap="gap.large">
                                                                <Text className="label-field limite" content={this.localize("HabilitarExportacao")} />
                                                                <Checkbox
                                                                    styles={{ margin: "10px 0 0 8px" }}
                                                                    checked={this.state.exportRecordings}
                                                                    onChange={this.toggleExportRecordings}
                                                                    toggle
                                                                />
                                                            </Flex>
                                                        </div>
                                                    </React.Fragment>
                                                }

                                                <React.Fragment>
                                                    <div className="inputField form-section not-first" >
                                                        <Text weight="bold" content={this.localize("ComentariosEncerramentoFila")} />
                                                    </div>

                                                    <div className="inputField">
                                                        <Flex vAlign="center" gap="gap.large">
                                                            <Text className="label-field limite" content={this.localize("HabilitarComentariosEncerramentoFila")} />
                                                            <Checkbox
                                                                styles={{ margin: "10px 0 0 8px" }}
                                                                checked={this.state.endQueueCommentsEnabled}
                                                                onChange={this.toggleEndQueueComments}
                                                                toggle
                                                            />
                                                        </Flex>
                                                    </div>
                                                </React.Fragment>
                                            </React.Fragment>
                                        }

                                        {this.state.selectedMenu == 5 &&
                                            this.state.features.includes(Features.GovBrAuthentication) &&
                                            <React.Fragment>
                                                <div className="inputField form-section not-first" >
                                                    <Text weight="bold" content={this.localize("Autenticacao")} />
                                                </div>

                                                <div className="inputField">
                                                    <Flex vAlign="center" gap="gap.large">
                                                        <Text className="label-field limite" content={this.localize("AutenticacaoGovBr")} />
                                                        <Checkbox
                                                            styles={{ margin: "10px 0 0 8px" }}
                                                            checked={this.state.govBrEnabled}
                                                            onChange={this.toggleGovBrEnabled}
                                                            toggle
                                                        />
                                                    </Flex>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </div>
                                </Flex.Item>
                            </Flex>
                        </div>

                        <div className="footerContainer">
                            <div className="buttonContainer">
                                <Button content={this.localize("Cancelar")} id="cancelBtn" onClick={this.onCancel} />
                                <Button content={this.localize("Salvar")} id="saveBtn" onClick={this.onSave} primary disabled={this.isSaveBtnDisabled()} />
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    public escFunction(event: any) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            dialog.url.submit();
        }
    }
}

const formBalcaoVirtualWithTranslation = withTranslation()(ServiceUnit);
export default formBalcaoVirtualWithTranslation;
